var render = function render(_c,_vm){return (_vm.props.value !== null)?_c('div',{staticClass:"array-field__item",class:{
    'cell-error': _vm.props.value === 'NaN',
  }},[_c('div',{staticClass:"array-field__ellipsis"},[_vm._v("\n    "+_vm._s(_vm.props.value === 'NaN'
        ? _vm.parent.$t('fieldErrors.invalidNumber')
        : _vm.$options.methods.formatFrontendNumber(_vm.props.field, _vm.props.value))+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }